module.exports = __webpack_public_path__ + "img/cover-redeem-bg.0d36c28c.png";